var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMarkerActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 44.999,
    viewBox: "0 0 35 44.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "j3ibtfw0ua",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffed40"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD569\\uCE58\\uAE30 1",
    transform: "translate(90.5 -77.5)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "url(#j3ibtfw0ua)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-73 123.136-.702-1.873-3.797-10.125a16.85 16.85 0 0 1-8.657-5.77A16.684 16.684 0 0 1-89.75 95a16.64 16.64 0 0 1 4.906-11.844A16.64 16.64 0 0 1-73 78.25a16.64 16.64 0 0 1 11.844 4.906A16.64 16.64 0 0 1-56.25 95a16.685 16.685 0 0 1-3.595 10.368 16.852 16.852 0 0 1-8.656 5.77l-3.797 10.125-.702 1.873z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-73 121 3.932-10.487C-62.133 108.76-57 102.48-57 95c0-8.837-7.164-16-16-16-8.837 0-16 7.163-16 16 0 7.48 5.132 13.76 12.067 15.513L-73 121m0 1.5a1.5 1.5 0 0 1-1.404-.974l-3.666-9.773a17.614 17.614 0 0 1-8.675-5.92A17.433 17.433 0 0 1-90.5 95a17.439 17.439 0 0 1 5.126-12.375A17.439 17.439 0 0 1-73 77.5a17.44 17.44 0 0 1 12.374 5.126A17.44 17.44 0 0 1-55.5 95a17.433 17.433 0 0 1-3.756 10.833 17.615 17.615 0 0 1-8.675 5.92l-3.664 9.773A1.5 1.5 0 0 1-73 122.5z",
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40647"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16",
    d: "M1040.137 271.347h-3.181v3.181",
    transform: "translate(-1026.456 -260.847)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 17",
    d: "M3.181 0H0v3.181",
    transform: "rotate(90 7 17.5)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18",
    d: "M3.181 0H0v3.181",
    transform: "rotate(-90 17.972 7.472)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 19",
    d: "M3.181 0H0v3.181",
    transform: "rotate(180 12.25 12.722)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40648"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13",
    d: "M1039.6 278.874v-2.386h7.638v2.386",
    transform: "translate(-1025.918 -262.98)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14",
    d: "M0 2.386V0h7.638v2.386",
    transform: "rotate(180 10.66 11.305)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 15",
    d: "M1036.6 281.621h12.409",
    transform: "translate(-1025.304 -263.462)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMarkerActive);
export default __webpack_public_path__ + "viewer/static/media/ico-marker-active.310bb588cb7371935a35ca8f7545fa86.svg";
export { ForwardRef as ReactComponent };